import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Settings } from '../../../interfaces/settings/settings';
import { DamageType, DamageTypeUpdateDTO } from '../../../models/damagecase/damage-type.model';
import { DamageCaseService } from '../../../services/damage-case.service';
import { ApiResult } from '../../../models/api-result';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { orderByComparator } from '../../../helpers/order';
import { WithName } from '../../../interfaces/settings/withname.interface';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../ui/confirm-dialog/confirm-dialog.component';
import { catchError, filter, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-damage-types',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTooltipModule],
  templateUrl: './damage-types.component.html',
  styleUrl: './damage-types.component.scss'
})
export class DamageTypesComponent implements OnInit {
  @Input() public settings!: Settings;

  damageTypes!: DamageType[];
  originalType!: DamageType | null;
  newTypeName: string = "";

  constructor(
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private damagecaseService: DamageCaseService) {
  }

  ngOnInit(): void {
    // Get DamageTypes
    this.damagecaseService.getDamageTypeList()
      .subscribe((response: ApiResult<DamageType[]>) => {
        if (response.success === true) {
          this.damageTypes = response.result;
        }
      })
  }

  createType(): void {
    if (this.newTypeName == "") {
      return;
    }

    this.damagecaseService.addDamageType(this.newTypeName)
      .subscribe((response: ApiResult<DamageType>)  => {
        if (response.success) {
          this.damageTypes.push(response.result);
          this.orderByName(this.damageTypes);
          this.newTypeName = "";
        }
      });
  }

  toggleType(type: DamageType) {
    type.active = !type.active;

    this.cdRef.detectChanges();
  }

  cancelEditType(type: DamageType) {
    type.editing = false;
    type.name = this.originalType!.name;
    type.active = !this.originalType!.active;
    this.originalType = null;

    this.cdRef.detectChanges();
  }

  saveType(type: DamageType) {
    if (!this.originalType) {
       return;
    }

    // Check if there are any changes
    if (type.name !== this.originalType.name || type.active !== this.originalType.active) {
      //console.log('Changes detected, saving...');
      // Call the API to save only if changes are detected
      const dto: DamageTypeUpdateDTO = DamageTypeUpdateDTO.fromDamageType(type);
      console.log("Save Type: ", dto);

      this.damagecaseService.updateDamageType(type)
        .subscribe(() => type.editing = false);
      
    } else {
      //console.log('No changes detected, skipping save.');
      type.editing = false;
    }

    this.cdRef.detectChanges();
  }

  deleteType(type: DamageType) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "80%",
        maxWidth: "450px",
        data: {
          title: `Skadetype - ${type.name}`,
          noButton: "NEJ",
          yesButton: "JA",
          message: "Vil du slette denne skadetype?"
        }
      })

      dialogRef.afterClosed()
      .pipe(
        filter(result => result === true), // Only proceed if user confirms
        switchMap(() => this.damagecaseService.deleteDamageType(type.id)),
        tap((response: ApiResult<boolean>) => {
          if (response.success) {
            this.damageTypes = this.damageTypes.filter(x => x.id !== type.id); // Immutable update for change detection
          }
        }),
        catchError(error => {
          console.error("Error deleting damage type:", error);
          return of(null);
        })
      )
      .subscribe();
  }

  editType(type: DamageType) {
    type.editing = true;
    this.originalType = { ...type };

    this.cdRef.detectChanges();
  }

    private orderByName<T extends WithName>(items: T[]): T[] {
        return items.sort((a, b) => orderByComparator(a.name, b.name));
    }
}

